import { breakpoints } from "./breakpoints";

(function ($) {

    $(function () {

        const $groups = $(".js-accordeon");
        const $menus = $(".m-sidebarFilters__title");
        let isDesktop = window.innerWidth >= breakpoints.viewport_lg;

        $menus.on("click", function () {
            toggleMenu($(this));
            setSidebarMaxHeight();
        });

        function toggleMenu($clickedMenu) {
            $groups.each(function () {
                const $group = $(this);
                const $top = $group.find(".m-sidebarFilters__title");
                const $content = $group.find(".m-sidebarFilters__subList");

                if ($clickedMenu[0] === $top[0]) {
                    const isOpen = $group.hasClass("-active");

                    if (isOpen) {
                        closeFilterGroup($group, $content);
                    } else {
                        openFilterGroup($group, $content);
                    }
                } else {
                    closeFilterGroup($group, $content);
                }
            });
        }

        function openFilterGroup($group, $content) {
            $group.addClass("-active");
            $content.css("height", $content[0].scrollHeight + 20 + "px");
        }

        function closeFilterGroup($group, $content) {
            $group.removeClass("-active");
            $content.css("height", "0");
        }

        function setSidebarMaxHeight() {
            clearTimeout(window.sidebarHeightTimeout);
            window.sidebarHeightTimeout = setTimeout(() => {
                let sidebarHeight = $('.js-sidebar').find('.js-sidebarHeight').height() + 50;
                $('.js-sidebar').css('max-height', sidebarHeight + 'px');
            }, 300);
        }

        // Initialize: Set height to 0 for hidden accordions
        $groups.each(function () {
            const $group = $(this);
            const $content = $group.find(".m-sidebarFilters__subList");
            if ($group.hasClass("-active")) {
                $content.css({
                    height: $content[0].scrollHeight + 20 + "px",
                    overflow: "hidden"
                });
            }
        });

    });

})(jQuery);